import * as React from 'react';
import FiltersBar from '../FiltersBar';
import LoadMore from '../LoadMore';
import NoResults from '../NoResults';
import { FiltersProvider } from '../../contexts/filters';
import { PostsProvider } from '../../contexts/posts';
import Search from '../filters/Search';
import Filters from '../Filters';
import PostsGrid from '../PostsGrid';
import Posts from '../Posts';
// import ResultCount from '../ResultCount';

const LayoutDefault = () => {
	return (
		<>
			<FiltersProvider>
				<FiltersBar>
					<Filters />
					<Search />
				</FiltersBar>
				<PostsProvider>
					<Posts>
						{/* <ResultCount foundPosts={0} /> */}
						<PostsGrid posts={[]} />
						<LoadMore page={0} maxNumPages={0} />
						<NoResults posts={[]} />
					</Posts>
				</PostsProvider>
			</FiltersProvider>
		</>
	);
};

LayoutDefault.displayName = 'LayoutDefault';

export default LayoutDefault;
